<ng-container *ngIf="standalonePage; then fullPage; else notFullPage"></ng-container>

<ng-template #fullPage>
    <div class="sh-page-template__main__wrapper">
        <div class="sh-page-template__main__content">
            <ng-container *ngTemplateOutlet="fullTable"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #notFullPage>
    <ng-container *ngIf="!condensed; else content">
        <ng-container *ngTemplateOutlet="fullTable"></ng-container>
    </ng-container>
</ng-template>

<ng-template #fullTable>
    <div class="sh-master-details-content-template">
        <div class="sh-master-details-content-template__master-content -sh-no-top-spacing">
            <div class="side-by-side">
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #content>
    <ng-container *ngIf="!condensed">
        <div class="filters" [id]="filterPanel.panelId" [class.filters--hidden]="filtersHidden">
            <sh-profile-facet-list
                *ngIf="facetProfile$ | async as profile"
                [facetProfile]="profile"
                [queryRestrictions]="facetQueryRestrictions$ | async"
                [facetRefreshTriggers]="[refresh$]"
                [showSummary]="false"
                [showTitle]="true"
                [collapseFacetsByDefault]="collapseFacetsByDefault"
                [hideNonDiscriminatingFacets]="hideNonDiscriminatingFacets"
                [resultTotal$]="facetResultTotal$"
                [reorderable]="true"
                [facetOrder]="facetOrder.order$ | async"
                [bodyTemplates]="submapBodyTemplates"
                [suppressedFacetKeys]="suppressedFacetKeys$ | async"
                (facetsReordered)="facetOrder.save($event)"
                (resetOrder)="facetOrder.reset()"
                (visibleFacetKeys)="onPanelVisibleFacetKeys($event)"
            >
                <div shFacetPanelHead class="filter-panel-head">
                    <div class="saved-queries-inline" *ngIf="enableSavedQueries">
                        <ng-container *ngIf="activeQuery$ | async as activeQuery; else noActiveQuery">
                            <div class="saved-queries-inline__active">
                                <span class="saved-queries-inline__name" [attr.title]="activeQuery.Name">{{ activeQuery.Name }}</span>
                                <span
                                    *ngIf="canUpdateQuery$ | async"
                                    class="saved-queries-inline__dot"
                                    [attr.title]="'components.saved-queries.inline.changed-tooltip' | translate"
                                ></span>
                                <button
                                    *ngIf="activeQuery.Context.IsEditable"
                                    type="button"
                                    class="sh-pure-square-icon-button--light sh-icon-button -sh-small"
                                    [attr.title]="
                                        ((canUpdateQuery$ | async)
                                            ? 'components.saved-queries.inline.save-tooltip'
                                            : 'components.saved-queries.inline.edit-tooltip'
                                        ) | translate: { name: activeQuery.Name }
                                    "
                                    (click)="onUpdateSavedQuery(activeQuery)"
                                >
                                    <svg
                                        sh-icon
                                        size="small"
                                        [name]="(canUpdateQuery$ | async) ? 'save' : 'edit'"
                                        class="sh-icon-button__icon"
                                        [class.saved-queries-inline__icon--changed]="canUpdateQuery$ | async"
                                        aria-hidden="true"
                                    ></svg>
                                </button>
                                <button
                                    *ngIf="activeQuery.Context.IsDeletable"
                                    type="button"
                                    class="sh-pure-square-icon-button--light sh-icon-button -sh-small"
                                    [attr.title]="'actions.common.delete' | translate"
                                    (click)="onDeleteSavedQuery(activeQuery)"
                                >
                                    <svg sh-icon size="small" name="trash" class="sh-icon-button__icon" aria-hidden="true"></svg>
                                </button>
                                <button
                                    type="button"
                                    class="sh-pure-square-icon-button--light sh-icon-button -sh-small"
                                    [attr.title]="'components.saved-queries.inline.deactivate-tooltip' | translate: { name: activeQuery.Name }"
                                    (click)="onDeactivateSavedQuery()"
                                >
                                    <svg sh-icon size="small" name="close" class="sh-icon-button__icon" aria-hidden="true"></svg>
                                </button>
                            </div>
                        </ng-container>
                        <ng-template #noActiveQuery>
                            <div class="saved-queries-inline__active" *ngIf="canSaveQuery$ | async">
                                <span class="saved-queries-inline__name saved-queries-inline__name--unsaved">
                                    {{ "components.saved-queries.inline.current-query" | translate }}
                                </span>
                                <button
                                    type="button"
                                    class="sh-pure-square-icon-button--light sh-icon-button -sh-small"
                                    [attr.title]="'components.saved-queries.actions.save' | translate"
                                    (click)="onSaveSavedQuery()"
                                >
                                    <svg sh-icon size="small" name="save" class="sh-icon-button__icon" aria-hidden="true"></svg>
                                </button>
                            </div>
                        </ng-template>
                        <button type="button" class="saved-queries-inline__load" (click)="onOpenLoadSavedQueryDialog()">
                            <svg sh-icon name="magnifier" class="saved-queries-inline__load-icon" aria-hidden="true"></svg>
                            {{ "components.saved-queries.actions.load" | translate }}
                        </button>
                    </div>
                </div>
            </sh-profile-facet-list>
        </div>
        <digihaven-export-sidepanel
            *ngIf="enableExportPanel && (exportPanelOpen$ | async)"
            [class.export-sidepanel--hidden]="filtersHidden"
            [count]="(records$ | async)?.paginationInfo?.totalNumberOfResults ?? null"
            [selectedCount]="(selectedRecordCount$ | async) ?? 0"
            [loading]="(loading$ | async) ?? false"
            [hasError]="(error$ | async) ?? false"
            [submitting]="(exportSubmitting$ | async) ?? false"
            [failure]="exportFailure$ | async"
            (close)="closeExportPanel()"
            (startDownload)="onStartDownload($event)"
            (scopeChanged)="onExportScopeChanged()"
        ></digihaven-export-sidepanel>
    </ng-container>
    <!--
        The grid table's selection bar is fixed, so it takes none of this stack's height: without the room
        reserved here it would cover whatever ends the content, which is the pagination.
    -->
    <div class="list sh-template-stack" [class.digihaven-has-selection-bar]="rendersGridTable && ((selectedRecordCount$ | async) ?? 0) > 0">
        <ng-container *ngIf="!condensed">
            <sh-page-header
                *ngIf="pageTitle && standalonePage; else emptyTitle"
                class="sh-template-stack__item -sh-is-page-header"
                [title]="pageTitle"
                [actionItems]="globalActionItems$ | async"
            >
                <digihaven-filter-panel-toggle
                    shPageHeaderLead
                    [open]="filterPanel.open"
                    [panelId]="filterPanel.panelId"
                    (toggled)="onToggleFilterPanel()"
                ></digihaven-filter-panel-toggle>
            </sh-page-header>
            <ng-template #emptyTitle>
                <div class="sh-template-stack__item -sh-is-page-header">
                    <digihaven-filter-panel-toggle
                        [open]="filterPanel.open"
                        [panelId]="filterPanel.panelId"
                        (toggled)="onToggleFilterPanel()"
                    ></digihaven-filter-panel-toggle>
                </div>
            </ng-template>
        </ng-container>
        <digihaven-overview-search-row
            *ngIf="!condensed"
            class="sh-template-stack__item"
            [overviewIds]="managedViewIds"
            [advancedSearchTag]="advancedSearchTag"
            [enableAdvancedSearch]="enableAdvancedSearch"
            [recordSearch]="userQuery$ | async"
            (queryChanges)="onQueryChange($event)"
        >
            <button
                *ngIf="enableExportPanel"
                type="button"
                class="sh-button--light search-row__export"
                [disabled]="(pagedResult$ | async)?.totalNumberOfResults === 0"
                (click)="openExportPanel()"
            >
                {{ "exports.sidepanel.launch" | translate }}
            </button>
        </digihaven-overview-search-row>

        <sh-notification
            class="sh-template-stack__item"
            *ngFor="let notification of notifications"
            [type]="notification.type"
            [title]="notification.title | translate"
            [message]="notification.message | translate"
            [messageList]="notification.messageList"
            [icon]="notification.icon"
        ></sh-notification>
        <digihaven-table-header *ngIf="records$ | async as records" [condensed]="condensed" [title]="(resultsTitle$ | async) ?? ''">
            <digihaven-active-filter-bar
                *ngIf="activeFilterPills$ | async as pills"
                [pills]="pills"
                [savedQueryActive]="!!(activeQuery$ | async)"
                (removePill)="onRemoveActiveFilter($event)"
                (clearAll)="onClearAllFilters()"
            ></digihaven-active-filter-bar>
        </digihaven-table-header>
        <!--
            HFBD-6: an empty list with an active submap looks like an empty list from any other cause, and the
            tree — normally the thing that says where you are — has gone blank at the same moment. So the one
            thing that is missing gets said: which folder is filtering, and that its pill above removes it.
            No new state, no parser change, no recovery logic; the pill already works.
        -->
        @if (staleSubmapSegments$ | async; as staleSubmap) {
            @if (staleSubmap.length) {
                <p class="stale-submap sh-template-stack__item">
                    {{ "facets.submap.stale" | translate: { folder: staleSubmap.join(" / ") } }}
                </p>
            }
        }
        @if (rendersGridTable) {
            <digihaven-hierarchical-list
                *ngIf="records$ | async as records"
                class="sh-template-stack__item"
                [rows]="hierarchyRows$ | async"
                [columns]="tableColumns$ | async"
                [childColumns]="childColumns$ | async"
                [isLoading]="loading$ | async"
                [hasError]="error$ | async"
                [enableSelect]="shouldEnableSelect$ | async"
                [hasRowActions]="!!(rowActionItems$ | async)?.length"
                [rowActions]="hierarchyRowActions$ | async"
                [actionBarActionItems]="actionBarActionItems$ | async"
                [batchActionItems]="batchActionItems$ | async"
                [totalNumberOfResults]="records.paginationInfo.totalNumberOfResults"
                [overviewId]="getViewId()"
                [currentSort]="currentSort$ | async"
                [activeColumnFilters]="(columnFilters$ | async) ?? []"
                [activeFacetFilters]="(activeFacetFilters$ | async) ?? []"
                [enumFacets]="enumFacets$ | async"
                [enumFacetFieldKeys]="(enumFacetFieldKeys$ | async) ?? []"
                [isFlattened]="tableFlattened$ | async"
                [showSubfolders]="showSubfolders$ | async"
                (rowNavigation)="onRowNavigation($event)"
                (selectionChanged)="onSelectionChange($event)"
                (recordInteraction)="onRecordInteraction($event)"
                (expandToggled)="onExpandToggled($event)"
                (moreChildrenRequested)="onFetchMoreChildren($event)"
                (collapseAllRequested)="onCollapseAll()"
                (sortChanged)="onSortInfoChange($event)"
                (columnFilterChanged)="onColumnFilterChanged($event.field, $event.value)"
                (enumFilterOpened)="onEnumFilterOpened($event)"
                (facetValueSelected)="onFacetValueSelected($event)"
                (enumFilterCleared)="onEnumFilterCleared($event)"
            ></digihaven-hierarchical-list>
        } @else {
            <digihaven-list
                *ngIf="records$ | async as records"
                class="sh-template-stack__item"
                [condensed]="condensed"
                [isLoading]="loading$ | async"
                [hasError]="error$ | async"
                [records]="recordList$ | async"
                [columns]="recordColumns$ | async"
                [fieldDefinitions]="fieldDefinitions$ | async"
                [rowActionItems]="rowActionItems$ | async"
                [actionBarActionItems]="actionBarActionItems$ | async"
                [batchActionItems]="batchActionItems$ | async"
                [enableSelect]="shouldEnableSelect$ | async"
                [resetSelection]="clearSelection$ | async"
                [overviewId]="getViewId()"
                [totalNumberOfResults]="records.paginationInfo.totalNumberOfResults"
                [currentSort]="currentSort$ | async"
                [activeColumnFilters]="(columnFilters$ | async) ?? []"
                [activeFacetFilters]="(activeFacetFilters$ | async) ?? []"
                [enumFacets]="enumFacets$ | async"
                [enumFacetFieldKeys]="(enumFacetFieldKeys$ | async) ?? []"
                (rowNavigation)="onRowNavigation($event)"
                (selectionChanged)="onSelectionChange($event)"
                (recordInteraction)="onRecordInteraction($event)"
                (sortChanged)="onSortInfoChange($event)"
                (columnFilterChanged)="onColumnFilterChanged($event.field, $event.value)"
                (enumFilterOpened)="onEnumFilterOpened($event)"
                (facetValueSelected)="onFacetValueSelected($event)"
                (enumFilterCleared)="onEnumFilterCleared($event)"
            ></digihaven-list>
        }
        <ng-container *ngIf="!condensed">
            <sh-pagination
                class="sh-template-stack__item"
                *ngIf="pagedResult$ | async as pagedResult"
                [paginationInfo]="pagedResult"
                [resultsPerPageOptions]="[5, 10, 25, 50]"
                [previousPageMsg]="'components.pagination.previous' | translate"
                [nextPageMsg]="'components.pagination.next' | translate"
                [perPageMsg]="'components.pagination.per-page' | translate"
                [scrollRef]="paginationScrollRef"
                (paginationInfoChanged)="paginationInfoChanged($any($event))"
            ></sh-pagination>
        </ng-container>
    </div>
</ng-template>

<!--
    HFBD-6: the Submap tree, handed to the filter panel as the body of the facet it stands in for. Declaring it
    here rather than above the facet list is what lets it keep the facet's title, the HFBD-2 collapse chevron,
    the HFBD-3 reorder handle and its pill — none of which it would get by rendering beside the panel.
-->
<ng-template #submapBody>
    <digihaven-submap-tree
        [values]="(submapValues$ | async) ?? []"
        [activeSegments]="(submapSegments$ | async) ?? []"
        [facetKey]="submapFacetKey"
        (selectionChanged)="onSubmapSelectionChanged($event)"
        (searchChanged)="onSubmapSearchChanged($event)"
    ></digihaven-submap-tree>
</ng-template>
